import { Fragment } from "react";

/**
 * Highlights all occurrences of `substr` within `text` by wrapping them in <mark>.
 * Case-insensitive by default.
 *
 * @param {string} text
 * @param {string} substr
 * @returns {JSX.Element}
 */
export function highlightWithMark(text, substr) {
  const safeText = String(text ?? "");
  const needle = String(substr ?? "");

  if (!needle) return <span>{safeText}</span>;

  const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const rx = new RegExp(`(${escapeRegExp(needle)})`, "gi");

  const parts = safeText.split(rx); // captured group keeps matches in the result

  return (
    <span>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i}>{part}</mark>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        )
      )}
    </span>
  );
}
